import {_} from "../util/dom";
import {vsprintf} from "sprintf-js";

export default class HtmlTemplate {

    constructor(selector) {
        this.init(selector);
    }

    init(selector) {
        if(typeof selector === "string") {
            this.template = _(selector);
        }
        else if(selector.nodeType) {
            this.template = selector;
        }
        else if(selector.jquery) {
            this.template = selector[0];
        }

        // make sure the class "hide" isn't on the template html
        // otherwise every element will be invisible :|
        const templateClone = this.template.cloneNode(true);

        // make sure to remove the id on the element html
        templateClone.setAttribute('id', '');
        templateClone.classList.remove("hide");

        this.templateHtml = templateClone.outerHTML;
    }

    fill(fillValues) {
        return vsprintf(this.templateHtml, fillValues);
    }

    fillMulti(listOfValues) {
        return listOfValues.reduce((html, values) => html + this.fill(values), "");
    }

}